import useSearchParam from "hooks/useSearchParam";

export const CROP_YEAR_ID_QUERY_STRING_KEY = "cropYearId";

const useSelectedCropYearId = () =>
  useSearchParam(CROP_YEAR_ID_QUERY_STRING_KEY);

export default useSelectedCropYearId;
